import Button from '@material-ui/core/Button';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import parse from 'html-react-parser';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import DIRECTV_GO from '~/assets/DIRECTV_GO_LOGO_HORIZONTAL_RGB.svg';
import logoSky from '~/assets/log-SKY.svg';
import Footer from '~/components/Footer';
import { api } from '~/services/api';
import { ApplicationState } from '~/store';
import { companyRequest } from '~/store/ducks/auth/actions';
import { AuthState } from '~/store/ducks/auth/types';
import { documentsRequest } from '~/store/ducks/documents/actions';
import { Container, Content, Header } from './styles';

interface Document {
  country_company_id: number;
  modify_dt: any;
  page_content_ds: any;
  page_id: number;
  page_nm: string;
  page_type_fl: string;
  status_fl: string;
  user_executor: string;
}

const DocumentDetail = (props: { match: any }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { company, signed } = useSelector<ApplicationState, AuthState>(
    state => state.auth,
  );

  const documents = useSelector<ApplicationState, any>(
    state => state.documents,
  );

  const [document, setDocument] = useState<Document>({
    country_company_id: 0,
    modify_dt: '',
    page_content_ds: '',
    page_id: 0,
    page_nm: '',
    page_type_fl: '',
    status_fl: '',
    user_executor: '',
  } as Document);

  useEffect(() => {
    const { match } = props;

    const redirect = async () => {
      try {
        const response = await api.get(
          `/v1/company/alias?company=${match.params.country_company}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: '',
            },
          },
        );
        if (
          match.params.slug === 'faq' &&
          response.data?.country_company_id === 2
        ) {
          history.push(`/${response.data?.path_alias_nm}`);
        }
      } catch (error) {
        history.push('/helpe');
      }
    };

    redirect();

    dispatch(companyRequest(match.params.country_company));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    if (company?.country_company_id) {
      dispatch(documentsRequest(company.country_company_id));
    }
  }, [company, dispatch]);

  useEffect(() => {
    const { match } = props;

    const getDocument = async () => {
      try {
        const documentIndex = documents.data.findIndex(
          (el: any) => el.slug === match.params.slug,
        );

        if (documentIndex !== -1) {
          const response = await api.get(
            `v1/pages/${documents.data[documentIndex].page_id}`,
            {
              headers: {
                company: company.country_company_id,
                Authorization: '',
              },
            },
          );

          const page_content_ds = JSON.parse(response.data.page_content_ds);

          setDocument({ ...response.data, page_content_ds });
        } else {
          history.push(`/${company?.path_alias_nm}`);
        }
      } catch (error) {}
    };

    if (documents.data.length > 0) {
      getDocument();
    }
  }, [company, dispatch, documents.data, history, props]);

  const setLogo = (company: number) => {
    if (company === 1) {
      return logoSky;
    } else {
      return DIRECTV_GO;
    }
  };

  return (
    <Container>
      <Header>
        <div className="content-header-faq">
          <div className="logo">Vrio</div>
          <div className="login">
            {signed ? (
              <a href={`/${company?.path_alias_nm}/home`}>
                <Button>Voltar ao menu principal</Button>
              </a>
            ) : (
              <a href={`/${company?.path_alias_nm}`}>
                <Button>Fazer login</Button>
              </a>
            )}

            {company?.country_company_id ? (
              <img
                style={{ height: 30, objectFit: 'contain', marginLeft: 10 }}
                src={setLogo(company.country_company_id)}
                alt={`logo ${company?.company?.company_name?.toUpperCase()}`}
              />
            ) : (
              ''
            )}
          </div>
        </div>
      </Header>
      <Content>
        <div className="heade-options">
          <ul>
            {documents.data.length > 0 &&
              documents.data.map((el: any) => (
                <li key={el.page_id}>
                  <Link to={`/${company?.path_alias_nm}/${el.slug}`}>
                    {el.page_nm}
                  </Link>
                </li>
              ))}
          </ul>
        </div>

        {document.page_type_fl == '2' ? (
          <>
            <div className="content-header">
              <h1>
                {document.page_content_ds.sanfona_title &&
                  document.page_content_ds.sanfona_title}
              </h1>
              <h4>
                {document.page_content_ds.sanfona_subtitle &&
                  document.page_content_ds.sanfona_subtitle}
              </h4>
            </div>

            <div className="faq-question-fix">
              {document.page_content_ds.sanfona_title &&
                parse(
                  document.page_content_ds.generalInformationSanfonaEditorState,
                )}
            </div>

            <div className="faq-question">
              {document.page_content_ds.sanfona_title &&
                document.page_content_ds.sanfonaEditorState.sanfona.map(
                  (el: any) => (
                    <ExpansionPanel key={el.id}>
                      <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography className="title">{el.header}</Typography>
                      </ExpansionPanelSummary>
                      <ExpansionPanelDetails>
                        {parse(el.body)}
                      </ExpansionPanelDetails>
                    </ExpansionPanel>
                  ),
                )}
            </div>
          </>
        ) : (
          <>
            <div className="content-header">
              <h1>
                {document.page_content_ds.document_title &&
                  document.page_content_ds.document_title}
              </h1>
              <h4>
                {document.page_content_ds.document_subtitle &&
                  document.page_content_ds.document_subtitle}
              </h4>
            </div>

            <div className="document-question-fix">
              {document.page_content_ds.document_title &&
                parse(document.page_content_ds.documentoEditorState)}
            </div>
          </>
        )}
      </Content>
      <Footer />
    </Container>
  );
};

export default DocumentDetail;
